import { render, staticRenderFns } from "./AnalyticsHearingItem.vue?vue&type=template&id=08ed8bf8&scoped=true"
import script from "./AnalyticsHearingItem.vue?vue&type=script&lang=js"
export * from "./AnalyticsHearingItem.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsHearingItem.vue?vue&type=style&index=0&id=08ed8bf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ed8bf8",
  null
  
)

export default component.exports